










































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { truncateText, transparentPng1x1 } from '@/utils/common'

@Component
export default class GuiaTissOpme extends Vue {
  get getBackofficeGlobalStore() { return getModule(BackofficeGlobalStore, this.$store) }
  get guiaTissGroupedByOpme() { return this.getBackofficeGlobalStore.guiaTissGroupedByOpme }

  assinatura(signature: string | null | undefined) {
    return `data:image/png;base64,${signature || transparentPng1x1()}`
  }


  maskText(sentence: string, limit: number = 9999) {
    if (['', null, undefined].includes(sentence)) return ''
    return truncateText(sentence, limit)
  }

  maskDateTime(date: any) {
    const formatter = new Intl.DateTimeFormat("pt-BR", {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'America/Sao_Paulo',
    })
    return ['', null, undefined].includes(date)
      ? ''
      : formatter.format(new Date(date))
  }

  maskDate(date: any) {
    const formatter = new Intl.DateTimeFormat('pt-BR')
    return ['', null, undefined].includes(date)
      ? ''
      : formatter.format(new Date(date))
  }

  maskMoney(value: any) {
    const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    return [undefined, null, '', 0].includes(value)
      ? ''
      : formatter.format(Number(value))
  }
}
